/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageSizeDto
 */
export interface ImageSizeDto {
    /**
     * 
     * @type {number}
     * @memberof ImageSizeDto
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof ImageSizeDto
     */
    height: number;
}

/**
 * Check if a given object implements the ImageSizeDto interface.
 */
export function instanceOfImageSizeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "width" in value;
    isInstance = isInstance && "height" in value;

    return isInstance;
}

export function ImageSizeDtoFromJSON(json: any): ImageSizeDto {
    return ImageSizeDtoFromJSONTyped(json, false);
}

export function ImageSizeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageSizeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'width': json['width'],
        'height': json['height'],
    };
}

export function ImageSizeDtoToJSON(value?: ImageSizeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'width': value.width,
        'height': value.height,
    };
}

